<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  />
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/PassportTemplates/table-headers'

import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePassportTemplates',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
